import { Component, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BILLINGPLATFORM_URL } from 'src/app/app.constants';
import { ContentState } from 'src/app/store/state/content.state';
import { setTitleComponent } from 'src/app/utils/titles.util';

@Component({
    selector: 'u4-cpp-billingplatform',
    templateUrl: './billingplatform.component.html',
    styleUrls: ['./billingplatform.component.scss'],
})
export class BillingPlatformComponent implements OnDestroy {

    public labels: { [key: string]: string };
    public redirectBillingplatformUrl = BILLINGPLATFORM_URL;
    public email: string;
    public descriptionOne: string;
    public descriptionTwo: string;
    public title$ = new Observable<any>();
    private destroy$: Subject<void> = new Subject<void>();

    constructor(
        private store: Store<ContentState>,
        private titleService: Title
    ) {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => {
            this.labels = labels;
            this.titleService.setTitle(setTitleComponent(this.labels['billingplatform.title']));
            this.descriptionOne = this.labels['billingplatform.description.one'];
            this.descriptionTwo = this.labels['billingplatform.description.two'];
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
